export enum FieldRenderingType {
  TEXT = 'TEXT',
  HEADING = 'HEADING',
  LONGTEXT = 'LONGTEXT',
  DATE = 'DATE',
  LINK = 'LINK',
  IDENTIFIER = 'IDENTIFIER',
  CRISREF = 'CRISREF',
  THUMBNAIL = 'THUMBNAIL',
  ATTACHMENT = 'ATTACHMENT',
  TABLE = 'TABLE',
  INLINE = 'INLINE',
  ORCID = 'ORCID',
  TAG = 'TAG',
  VALUEPAIR = 'VALUEPAIR',
  HTML = 'HTML',
  LONGHTML = 'LONGHTML',
  ADVANCEDATTACHMENT = 'ADVANCEDATTACHMENT',
  SIMPLEATTACHMENT = 'SIMPLEATTACHMENT',
  AUTHORITYLINK = 'AUTHORITYLINK',
  CCLICENSEFULL = 'CCLICENSEFULL',
  CCLICENSE = 'CCLICENSE',

}
